import React, { useEffect, useState } from "react";
import { DownArrow } from "../../../IconTheme";

import Select from "react-select";
import { data } from "../../../assets/data/data";
import Pagination from "./Pagination";
import ProjectCard from "./ProjectCard";
import Sklenton from "./Sklenton";

const data1 = [
	{ value: "ocean", label: "BSC" },
	{ value: "blue", label: "ETH", isDisabled: true },
	{ value: "purple", label: "Telos" },
	{ value: "red", label: "Polygon" },
	{ value: "orange", label: "DOGE" },
	{ value: "yellow", label: "BTC" },
];
const data2 = [
	{ value: "ocean", label: "All Status" },
	{ value: "blue", label: "ETH", isDisabled: true },
	{ value: "purple", label: "Telos" },
	{ value: "red", label: "Polygon" },
	{ value: "orange", label: "DOGE" },
	{ value: "yellow", label: "BTC" },
];
const data3 = [
	{ value: "ocean", label: "No Sort" },
	{ value: "blue", label: "ETH", isDisabled: true },
	{ value: "purple", label: "Telos" },
	{ value: "red", label: "Polygon" },
	{ value: "orange", label: "DOGE" },
	{ value: "yellow", label: "BTC" },
];

const Project = () => {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setLoaded(true);
		}, 3000);
	}, []);

	return (
		<section className="section-gap bg-section">
			<div className="container">
				<div className="section-title">
					<h4>Find the project you want</h4>
					<div className="d-flex flex-wrap" style={{ gap: "24px" }}>
						<div className="floating-label-select multiple">
							<label>
								<span className="bg-section">Networks</span>
							</label>
							<Select
								closeMenuOnSelect={false}
								defaultValue={[data1[2], data1[1]]}
								isMulti
								options={data1}
							/>
							<div className="angle-icon">
								<DownArrow />
							</div>
						</div>
						<div className="floating-label-select">
							<label>
								<span className="bg-section">Filter By</span>
							</label>
							<Select
								className="basic-single"
								classNamePrefix="select"
								defaultValue={data2[0]}
								name="filter"
								options={data2}
							/>
							<div className="angle-icon">
								<DownArrow />
							</div>
						</div>
						<div className="floating-label-select">
							<label>
								<span className="bg-section">Sort By</span>
							</label>
							<Select
								className="basic-single"
								classNamePrefix="select"
								defaultValue={data3[0]}
								name="sort"
								options={data3}
							/>
							<div className="angle-icon">
								<DownArrow />
							</div>
						</div>
					</div>
				</div>
				<div className="row g-4 justify-content-center">
					{data?.map((item, i) =>
						loaded ? (
							<div className="col-md-6 col-xl-4" key={i}>
								<ProjectCard {...item} />
							</div>
						) : (
							<div className="col-md-6 col-xl-4" key={i}>
								<Sklenton />
							</div>
						)
					)}
				</div>
				<Pagination />
			</div>
		</section>
	);
};

export default Project;
